import { lazy } from "react";

const Home = lazy(() => import("../pages/Home/Home"));
const Signin = lazy(() => import("../pages/Signin/Signin"));
const Services = lazy(() => import("../pages/Services/Services"));
const Recharges = lazy(() => import("../pages/Recharges/Recharges"));
const Accounts = lazy(() => import("../pages/Accounts/Accounts"));
const Movements = lazy(() => import("../pages/Movements/Movements"));

const CreateCategory = lazy(() => import("../pages/CreateCategory/CreateCategory"));
const Combos = lazy(() => import("../pages/Combos/Combos"));
const RechargeSettings = lazy(() => import("../pages/RechargeSettings/RechargeSettings"));
const CommercialUsers = lazy(() => import("../pages/CommercialUsers/CommercialUsers"));
const BrebIngestions = lazy(() => import("../pages/BrebIngestions/BrebIngestions"));
const CredentialTemplate = lazy(() => import("../pages/CredentialTemplate/CredentialTemplate"));
const ProfitabilityDashboard = lazy(() => import("../pages/Profitability/ProfitabilityDashboard"));

const routes = [
    { path: '/home', component: Home },
    { path: '/', component: Signin },
    { path: '/services', component: Services },
    { path: '/servicios', component: Services },
    { path: '/recharges', component: Recharges },
    { path: '/accounts', component: Accounts },
    { path: '/movements', component: Movements },
    { path: '/categories', component: CreateCategory },
    { path: '/combos', component: Combos },
    { path: '/recharge-settings', component: RechargeSettings },
    { path: '/commercial-users', component: CommercialUsers },
    { path: '/breb-ingestions', component: BrebIngestions },
    { path: '/credential-template', component: CredentialTemplate },
    { path: '/profitability', component: ProfitabilityDashboard }
];
  
export default routes;
